import { IChatMessage, IChatMessages, SenderSource } from '@enuan/chat__utils';
import {
	IClientMessage,
	IClientMessageMeta,
} from '../interfaces/IClientMessage';

export const ClientMessage = <T extends IChatMessages>(
	message: IChatMessage<T>,
	meta: Partial<IClientMessageMeta> = {}
): IClientMessage<T> => {
	const _meta: IClientMessageMeta = {
		...meta,
		sent: meta.sent ?? message.timestamp ?? new Date().toISOString(),
		read: meta.read || message.sender === SenderSource.USER,
	};

	return {
		...message,
		_meta,
	};
};
